import Skeleton from 'react-loading-skeleton';
import React from "react";
import { Span, P } from "..";

export function UpdatesAndCommentsSkeleton() {
    return <ul className="timeline">
        <li className="updates">
            <div className="camp-update-info">
                <Span className="camp-update-date"><Skeleton count={1} width={120} /></Span>
                <Span className="camp-update-by"><Skeleton count={1} width={100} />
                </Span>
            </div>
            <div className="camp-gallery-info default">
                <P><Skeleton count={1} width={'15%'} /></P>
            </div>
            <div className="update-data img-gallery">
                <ul>
                    <li>
                        <Skeleton count={1} height={'100%'} width={'100'} />
                    </li>
                    <li>
                        <Skeleton count={1} height={'100%'} width={'100'} />
                    </li>
                    <li>
                        <Skeleton count={1} height={'100%'} width={'100'} />
                    </li>

                </ul>
            </div>
        </li>
    </ul>
}